import React, { FC } from 'react';
import * as classes from './TeamMemberCard.module.scss';
import { ITeamMember } from '../../../interfaces/professional/Professional';
import noPhotoImg from '../../../assets/images/no-photo.png';
import cn from 'classnames';
import ShineHover from '../ShineHover/ShineHover';

interface Props extends ITeamMember {
  roundedImage?: boolean;
}

const TeamMemberCard: FC<Props> = ({ name, picture, position, contact, roundedImage }) => {
  return (
    <div className={classes.wrapper}>
      <ShineHover>
        <div
          className={cn(classes.image, roundedImage && classes.rounded)}
          style={{ backgroundImage: `url("${picture ? picture.url : noPhotoImg}")` }}
        />
      </ShineHover>
      <div className={classes.name}>{name}</div>
      <div className={classes.position}>{position}</div>
      <div className={classes.contact}>{contact}</div>
    </div>
  );
};

export default TeamMemberCard;
